<template>
  <modal content-class="leads-upload-modal"
         title="Importar banco de dados"
         :value="showing"
         :maxWidth="500"
         @input="emitShowing">

    <app-form @submit="uploadNewDatabase">
      <text-field class="leads-upload-modal-source"
                  v-model="form.source"
                  label="Origem dos dados"
                  name="Origem dos dados"
                  help="Nome que será utilizado para identificar a automação dentro do WiFeed."
                  validate="required" />

      <dropzone class="leads-upload-modal-file"
                v-model="form.file"
                name="Arquivo" />

      <div class="leads-upload-modal-models">
        <a class="leads-upload-modal-models-item"
           download
           href="https://wifeed-public.s3.sa-east-1.amazonaws.com/model-external-csv.csv">Baixar modelo de arquivo em .csv</a>

        <a class="leads-upload-modal-models-item"
           download
           href=" https://wifeed-public.s3.sa-east-1.amazonaws.com/modelo-exemplo-xlsx.xlsx">Baixar modelo de arquivo em .xlsx</a>

      </div>

      <app-button class="leads-upload-modal-action btn btn-primary btn-round"
                  label="Importar"
                  type="submit"
                  primary />
    </app-form>

  </modal>
</template>

<script>
import EventBus from "@packages/event-bus/index";
import Dropzone from "@components/form/Dropzone.vue";
import TextField from "@components/form/TextField.vue";
import AppForm from "@components/form/Form.vue";
import Modal from "@components/generic/Modal.vue";
import AppButton from "@/components/generic/button/Button";

export default {
  components: {
    Modal,
    AppForm,
    TextField,
    AppButton,
    Dropzone,
  },

  props: {
    showing: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: {
        source: undefined,
        file: undefined,
      },
    };
  },

  created() {},

  methods: {
    emitShowing(showing) {
      this.$emit("update:showing", showing);
    },
    async uploadNewDatabase() {
      let formData = new FormData();
      formData.append("file", this.form.file);
      formData.append("source", this.form.source);

      await this.$api.leads.uploadDatabase({
        data: formData,
      });

      EventBus.$emit("show-message", {
        type: "SUCCESS",
        message: "Banco de dados adicionado com sucesso!",
      });

      this.emitShowing(false);
      this.$emit("added");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.leads-upload-modal {
  .leads-upload-modal-file {
    margin-bottom: 10px;
  }

  .leads-upload-modal-action {
    margin: 0 auto;
    display: block;
  }

  .leads-upload-modal-models {
    .leads-upload-modal-models-item {
      display: block;
      text-align: center;
      margin: 0;
      font-size: 15px;
      color: $primary;
      cursor: pointer;
      margin-bottom: 10px;
    }
  }
}
</style>
